<div class="container-fluid g-0 m-0">
  <div class="row g-0 m-0 d-flex pt-5 align-items-center">
    <div class="col-md-1 d-flex pe-4 justify-content-end">
      <div class="button-back pb-1" [routerLink]="['/analysis-report/energy-per-phase']">
        <svg-icon alt="Back" src="assets/core/back-button.svg"></svg-icon>
      </div>
    </div>
    <div class="col-md-6">
      <h2 class="col pb-2 m-0 title">
        {{ "REPORT_ENERGYPERPHASE" | translate }}
        {{ "DETAILS" | translate }}
      </h2>
      <h6 class="col subtitle">
        {{ "REPORT_ENERGYPERPHASESUBTITLE" | translate }}
      </h6>
    </div>
    <div class="col-md-5 d-flex justify-content-end align-items-center gap-2 pe-5">
      <div class="position-relative">
        <div class="settings-button ps-3 pe-3 pb-2 pt-1" (click)="toggleSelectOption()">
          <svg-icon alt="Settings" class="hover-effect" src="assets/core/table-button/filter.svg"></svg-icon>
        </div>

        <!-- Select Option Modal -->
        <div class="select-option-overlay" *ngIf="isSelectOptionOpen" (click)="closeSelectOption()"></div>
        <div class="select-option-modal" *ngIf="isSelectOptionOpen">
          <div class="select-option-header">
            <span>{{ "SELECT_OPTION" | translate }}</span>
            <img alt="Close" src="assets/device/x.svg" (click)="closeSelectOption()" class="close-icon" />
          </div>
          <div class="select-option-item" (click)="selectReadOption(ReadsType.Processed)">
            <span>{{ "PROCESSED_READ" | translate }}</span>
            <input class="radio-div" type="radio" [checked]="selectedReadOption === ReadsType.Processed" readonly />
          </div>
          <div class="select-option-item" (click)="selectReadOption(ReadsType.Raw)">
            <span>{{ "RAW_READ" | translate }}</span>
            <input type="radio" [checked]="selectedReadOption === ReadsType.Raw" readonly />
          </div>
          <div class="select-option-footer">
            <button class="apply-btn" (click)="applyReadOption()">{{ "APPLY" | translate }}</button>
          </div>
        </div>
      </div>

      @if (authService.isAuthorized([PermissionsEnum.Report_energy_per_phase_download])) {
      <div class="download-button ps-3 pe-3 pb-2 pt-1" (click)="download()">
        <svg-icon alt="Download" class="hover-effect" src="assets/core/table/download.svg"></svg-icon>
      </div>
      }
    </div>
  </div>
  <div #tableContainer class="table-container mt-5">
    <table>
      <thead>
        <tr>
          <td class="custom-width">
            {{ "TIME" | translate | uppercase }}
          </td>
          <td colspan="2">{{ "ACTIVE" | translate }} {{ "ENERGY" | translate }} L1</td>
          <td colspan="2">{{ "ACTIVE" | translate }} {{ "ENERGY" | translate }} L2</td>
          <td colspan="2">{{ "ACTIVE" | translate }} {{ "ENERGY" | translate }} L3</td>
          <td colspan="2">{{ "REACTIVE" | translate }} {{ "ENERGY" | translate }} L1</td>
          <td colspan="2">{{ "REACTIVE" | translate }} {{ "ENERGY" | translate }} L2</td>
          <td colspan="2">{{ "REACTIVE" | translate }} {{ "ENERGY" | translate }} L3</td>
          <td colspan="2">{{ "APPARENT" | translate }} {{ "ENERGY" | translate }} L1</td>
          <td colspan="2">{{ "APPARENT" | translate }} {{ "ENERGY" | translate }} L2</td>
          <td colspan="2">{{ "APPARENT" | translate }} {{ "ENERGY" | translate }} L3</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of data">
          <td class="table-name-number">
            <span>{{ item.meterTime | date: "dd MMM yyyy, h:mm a" }}</span>
          </td>

          <!-- Active Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.l1ActiveEnergyImport + ' WH'">
                {{ item.l1ActiveEnergyImport == null ? "N/A" :
                item.l1ActiveEnergyImport! | unitConverter: "WH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.l1ActiveEnergyExport + ' WH'">
                {{ item.l1ActiveEnergyExport == null ? "N/A" :
                item.l1ActiveEnergyExport! | unitConverter: "WH" }}
              </span>
            </div>
          </td>
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.l2ActiveEnergyImport + ' WH'">
                {{ item.l2ActiveEnergyImport == null ? "N/A" :
                item.l2ActiveEnergyImport! | unitConverter: "WH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.l2ActiveEnergyExport + ' WH'">
                {{ item.l2ActiveEnergyExport == null ? "N/A" :
                item.l2ActiveEnergyExport! | unitConverter: "WH" }}
              </span>
            </div>
          </td>
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.l3ActiveEnergyImport + ' WH'">
                {{ item.l3ActiveEnergyImport == null ? "N/A" :
                item.l3ActiveEnergyImport! | unitConverter: "WH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.l3ActiveEnergyExport + ' WH'">
                {{ item.l3ActiveEnergyExport == null ? "N/A" :
                item.l3ActiveEnergyExport! | unitConverter: "WH" }}
              </span>
            </div>
          </td>

          <!-- Reactive Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.l1ReactiveEnergyImport + ' VARH'">
                {{ item.l1ReactiveEnergyImport == null ? "N/A" :
                item.l1ReactiveEnergyImport! | unitConverter: "VARH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.l1ReactiveEnergyExport + ' VARH'">
                {{ item.l1ReactiveEnergyExport == null ? "N/A" :
                item.l1ReactiveEnergyExport! | unitConverter: "VARH" }}
              </span>
            </div>
          </td>
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.l2ReactiveEnergyImport + ' VARH'">
                {{ item.l2ReactiveEnergyImport == null ? "N/A" :
                item.l2ReactiveEnergyImport! | unitConverter: "VARH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.l2ReactiveEnergyExport + ' VARH'">
                {{ item.l2ReactiveEnergyExport == null ? "N/A" :
                item.l2ReactiveEnergyExport! | unitConverter: "VARH" }}
              </span>
            </div>
          </td>
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.l3ReactiveEnergyImport + ' VARH'">
                {{ item.l3ReactiveEnergyImport == null ? "N/A" :
                item.l3ReactiveEnergyImport! | unitConverter: "VARH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.l3ReactiveEnergyExport + ' VARH'">
                {{ item.l3ReactiveEnergyExport == null ? "N/A" :
                item.l3ReactiveEnergyExport! | unitConverter: "VARH" }}
              </span>
            </div>
          </td>

          <!-- Apparent Energy -->
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.l1ApparentEnergyImport + ' VAH'">
                {{ item.l1ApparentEnergyImport == null ? "N/A" :
                item.l1ApparentEnergyImport! | unitConverter: "VAH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.l1ApparentEnergyExport + ' VAH'">
                {{ item.l1ApparentEnergyExport == null ? "N/A" :
                item.l1ApparentEnergyExport! | unitConverter: "VAH" }}
              </span>
            </div>
          </td>
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.l2ApparentEnergyImport + ' VAH'">
                {{ item.l2ApparentEnergyImport == null ? "N/A" :
                item.l2ApparentEnergyImport! | unitConverter: "VAH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.l2ApparentEnergyExport + ' VAH'">
                {{ item.l2ApparentEnergyExport == null ? "N/A" :
                item.l2ApparentEnergyExport! | unitConverter: "VAH" }}
              </span>
            </div>
          </td>
          <td class="import-cell">
            <div class="cell">
              <img alt="Import" src="assets/load-profile/im.svg" />
              <span [attr.title]="item.l3ApparentEnergyImport + ' VAH'">
                {{ item.l3ApparentEnergyImport == null ? "N/A" :
                item.l3ApparentEnergyImport! | unitConverter: "VAH" }}
              </span>
            </div>
          </td>
          <td class="export-cell">
            <div class="cell">
              <img alt="Export" src="assets/load-profile/ex.svg" />
              <span [attr.title]="item.l3ApparentEnergyExport + ' VAH'">
                {{ item.l3ApparentEnergyExport == null ? "N/A" :
                item.l3ApparentEnergyExport! | unitConverter: "VAH" }}
              </span>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div class="container-down mb-5">
    <app-pagination [lastPageSize]="lastPageSize" [numberOfDevices]="numberOfCommands" [pageSize]="pageSize"
      [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-pagination>
  </div>
</div>